import { render, staticRenderFns } from "./ui-image-croper.vue?vue&type=template&id=73926950"
import script from "./ui-image-croper.vue?vue&type=script&lang=ts"
export * from "./ui-image-croper.vue?vue&type=script&lang=ts"
import style0 from "./ui-image-croper.vue?vue&type=style&index=0&id=73926950&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports